import React from 'react';
import mobileCondition from '../../constants/mobileCondition';

import sitePlaceholder from '../../assets/images/sitePlaceholder.png';
import sitePlaceholderMobile from '../../assets/images/sitePlaceholderMobile.png';
import './SitePlaceholder.scss';

const SitePlaceholder = () => (
  <div
    className="site-placeholder"
    style={{
      backgroundImage: `url(${mobileCondition ? sitePlaceholderMobile : sitePlaceholder})`,
    }}
  />
);

export default SitePlaceholder;
